import React from "react";
import { Accordion } from "react-bootstrap";

//modify first <Accordion> tag <Accordion defaultActiveKey="1"> to start as open

const OpportunityAccordion = ({ project, renderField }) => {
  return (
    <Accordion>
      <Accordion.Item eventKey="1">
        <Accordion.Header>Opportunity Information</Accordion.Header>
        <Accordion.Body>
          {renderField("Opportunity Name", project.Deal_Name || "")}
          {renderField("Change Order", null)}
          {renderField("Market", project.Market || "")}
          {renderField("Stage", project.Stage || "")}
          {renderField("Loss Narrative", project.Loss_Narrative || "")}
          {renderField("Company Name", project.Account_Name?.name || "")}
          {renderField("Company Market", project.Company_Market)}
          {renderField("Primary Street", project.Primary_Street)}
          {renderField("Primary Street 2", project.Primary_Street_2)}
          {renderField("Primary State", project.Primary_State)}
          {renderField("Primary City", project.Primary_City)}
          {renderField("Primary Zip Code", project.Primary_Code_Zip)}
          {renderField(
            "Customer Tower Designation",
            project.Customer_Tower_Designation
          )}
          {renderField(
            "ATS Tower Serial Number",
            project.ATS_Tower_Serial_Number
          )}
          {renderField("Customer RFQ Number", project.Customer_RFQ)}
          {renderField("Contact Name", project.Contact_Name?.name || "")}
          {renderField("Secondary Contact", project.Secondary_Contact?.name || "")}
          {renderField("Project Name", project.Project_Name)}
          {renderField("Plant Type", project.Plant_Type_2)}
          {renderField("ATS Products", project.ATS_productss)}
          {renderField(
            "Tech MGR Visited Site (Not Sales Rep)",
            project.ATS_RTM_Visit_Site
          )}
          {renderField("3D Camera Used?", project.D_Camera_Used)}
          {renderField("Opportunity Owner", project.Owner?.name || "")}
          {renderField("Opportunity Co-Owner", project.Opportunity_Co_Owner)}
          {renderField("Project Manager", project.Project_Manager)}
          {renderField("Proposal Manager", project.Proposal_Person)}
          {renderField("Estimator", project.Estimator)}
          {renderField("Customer Sale Price", project.Customer_Sale_Price)}
          {renderField("Sales Rep Firm", project.Sales_Rep)}
          {renderField("Sales Rep Person", project.ATS_Sales_Person)}
          {renderField("2nd Sales Rep Firm", null)}
          {renderField("2nd Sales Rep Person", null)}
          {renderField("Actual Top Prospects Opportunity", null)}
          {renderField("Key Project", project.Key_Project ? "True" : "False")}
          {renderField("Internal Meeting to Review", project.Internal_Meeting)}
          {renderField("Competitors", project.Competitors1)}

          {renderField("Budget Approved?", null)}
          {renderField("Customer PO", project.Customer_PO)}
          {renderField("Formal RFQ", project.Firm_RFQ ? "True" : "False")}
          {renderField("Date Bid Due", project.Date_Bid_Due)}
          {renderField("Time Bid Due", project.Time_Bid_Due)}
          {renderField("Closing Date", project.Closing_Date)}
          {renderField("Scope of Work Rec'd", project.Scope_of_Work)}
          {renderField("Quote Date", project.Quote_Date)}
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="2">
        <Accordion.Header>Commercial Info</Accordion.Header>
        <Accordion.Body>
          {renderField("Pricing Type", project.Pricing_Type)}
          {renderField("Sales Taxes by", project.Sales_Taxes_by)}
          {renderField("Bid Bond", project.Bid_Bond)}
          {renderField("Bid Bond Amount", project.Bid_Bond_Amount)}
          {renderField(
            "Performance and Payment Bond Required",
            project.Performance_and_Payment_Bond_Required
          )}
          {renderField(
            "Payment Performance Bond Amount",
            project.Payment_Performance_Bond_Amount
          )}
          {renderField("Liquated Damages", project.Liquated_Damages)}
          {renderField("Thermal LD's", project.Thermal_LD_s)}
          {renderField("Schedule LD's", project.Schedule_LD_s)}
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="3">
        <Accordion.Header>Scope of Work</Accordion.Header>
        <Accordion.Body>
          {renderField("Base Bid", project.Base_Bid)}
          {renderField("Add Option 1", project.Add_Option_11)}
          {renderField("Add Option 2", project.Add_Option_21)}
          {renderField("Add Option 3", project.Add_Option_31)}
          {renderField("Add Option 4", project.Add_Option_41)}
          {renderField("Add Option 5", project.Add_Option_51)}
          {renderField("Notes", project.Description)}
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="4">
        <Accordion.Header>Safety</Accordion.Header>
        <Accordion.Body>
          {renderField("Fire Watch", project.Fire_Watch)}
          {renderField(
            "Full Time Safety Required",
            project.Full_Time_Safety_Required
          )}
          {renderField(
            "LOTO Average Down Time",
            project.LOTO_Average_Down_Time
          )}
          {renderField(
            "Cold Water Basic Covers Required",
            project.Cold_Water_Basin_Covers_Required
          )}
          {renderField("Asbestos Removal", project.Asbestos_Removal)}
          {renderField(
            "Asbestos Removal Components",
            project.Asbestos_Removal_Components
          )}
          {renderField(
            "Other Hazardous Removal",
            project.Other_Hazardous_Removal
          )}
          {renderField(
            "Confined Space Attendent",
            project.Confined_Space_Attendent
          )}
          {renderField(
            "Mobile Multi-Gas Detection Monitor",
            project.Air_Monitor
          )}
          {renderField("Safety Notes", project.Safety_Notes)}
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="5">
        <Accordion.Header>Construction & Materials</Accordion.Header>
        <Accordion.Body>
          {renderField(
            "Number of Cells Down During Construction",
            project.Number_of_Cells_Down_During_Construction
          )}
          {renderField("Labor By", project.Labor_By)}
          {renderField("Labor Type", project.Labor_Type)}
          {renderField(
            "Prevail or Union, Wages Attached",
            project.Prevail_or_Union_Wages_Attached
          )}
          {renderField(
            "Access Around SIDES Tower",
            project.Access_Around_Tower
          )}
          {renderField(
            "Access Around ENDS of Tower",
            project.Decision_Based_On
          )}
          {renderField("Lumber Type", project.Lumber_Type)}
          {renderField("Hardware", project.Hardware)}
          {renderField("Fiberglass Type", project.Fiberglass_Type)}
          {renderField("Freight By", project.Freight_By)}
          {renderField("Freight Detail", project.Frieght_Detail)}
          {renderField("Dumpsters By", project.Dumpsters_By)}
          {renderField("Electric Power", project.Electric_Power)}
          {renderField("Forklift By", project.Forklift_By)}
          {renderField("Manlift By", project.Manlift_By)}
          {renderField("Haul Stage", project.Haul_Stage)}
          {renderField("Unload By", project.Unload_By)}
          {renderField("Fan Stack Fire Rating", project.Fan_Stack_Fire_Rating)}
          {renderField("Sheathing Fire Rating", project.Sheathing_Fire_Rating)}
          {renderField(
            "Additional Construction Access Info",
            project.Additional_Construction_Access_Info
          )}
          {renderField("Crane By", project.Crane_By)}
          {renderField(
            "Sanitary and Wash Station Facilities By",
            project.Sanitary_Facilities_By
          )}
          {renderField("Subcontractors", project.Subcontractors)}
          {renderField("ATS Shredder", project.ATS_Shredder)}
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="6">
        <Accordion.Header>Key Project Dates</Accordion.Header>
        <Accordion.Body>
          {renderField("Outage or Not", project.Outage_or_Not)}
          {project.Outage_or_Not === "Yes" && (
            <>
              {renderField("Outage Dates Firm", project.Outage_Dates_Firm)}
              {renderField(
                "Outage Calendar Duration Days",
                project.Outage_Calender_Duration_Days
              )}
              {renderField("Outage Start Date", project.Outage_Start_Date)}
              {renderField("Outage End Date", project.Outage_End_Date)}
              {renderField(
                "Outage or Timing Notes",
                project.Outage_or_Timing_Notes
              )}
            </>
          )}
          {renderField("Working Hours in Day", project.Working_Hours_in_Day)}
          {renderField("Working Days", project.Working_Days)}
          {renderField(
            "Tower Available Start Date",
            project.Tower_Available_Start_Date
          )}
          {renderField(
            "Tower Available End Date",
            project.Tower_Available_End_Date
          )}
          {renderField(
            "Customer Clean and Drain CWB",
            project.Customer_Clean_and_Drain_CWB_If_Outage
          )}
          {renderField(
            "Client Clean Cold Water Basin",
            project.Client_Clean_Cold_Water_Basin
          )}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default OpportunityAccordion;
